import { selectCustomer, selectCustomerNumber, selectLoadingState, selectShowAutoclaveConfirmationAlertForCorp } from '../../../redux/customer'
import { useAppSelector } from '../../../redux/store'
import './Dashboard.css'
import ComplianceSummary from './ComplianceSummary'
import Practices from './Practices'
import LoadingScreen from '../../../components/LoadingScreen'
import { Alert, Link } from '@mui/material'
import { selectIsAdminOrOwner } from '../../../redux/user'
import { useNavigate } from 'react-router-dom'
import CreditHoldBanner from '../../../components/CreditHoldBanner'
import { LoadingState } from '../../../types'

const Dashboard = () => {
  const customer = useAppSelector(selectCustomer)
  const customerNumber = useAppSelector(selectCustomerNumber)
  const showAutoclaveConfirmation = useAppSelector(selectShowAutoclaveConfirmationAlertForCorp)
  const loadingStates = useAppSelector(selectLoadingState)
  const isAdminOrOwner = useAppSelector(selectIsAdminOrOwner)
  const navigate = useNavigate()

  const isDataLoaded = customer
    && customerNumber
    && loadingStates === LoadingState.Done

  return isDataLoaded ? (
    <div className='corp-dashboard-container'>
      {isAdminOrOwner && showAutoclaveConfirmation && (
        <Alert variant="filled" severity="error" sx={{ mb: 2 }}>
          FOR OWNER AND ADMIN REVIEW: Check the status of autoclave confirmations at your locations. <Link sx={{ color: 'lightskyblue', cursor: 'pointer' }} onClick={() => navigate('/corp/biological/autoclave-confirmation-status')}>Go to the Confirmation Status page.</Link>
        </Alert>
      )}
      <ComplianceSummary />
      <CreditHoldBanner customer={customer} />
      <Practices />
    </div>
  ) : <LoadingScreen />
}

export default Dashboard